import type { ComponentStyleConfig } from '@chakra-ui/theme';

/**
 * ButtonToggle — an icon-only, always-"naked" toggle button.
 * Colour is driven by `currentColor` on the button, defaulting to semantic
 * tokens (`neutral.fg-primary` at rest, `neutral.fg-secondary` on hover) that
 * the consumer can override via the component's colour props.
 *
 * `_focusVisible` and `_disabled` are accessibility additions, not part of the
 * Figma design (which only defines default + hover states).
 */
export const styleConfig: ComponentStyleConfig = {
  baseStyle: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSize: '5',
    padding: 0,
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    appearance: 'none',
    color: 'neutral.fg-primary',
    _hover: {
      color: 'neutral.fg-secondary',
    },
    _focusVisible: {
      outline: '2px solid',
      outlineColor: 'neutral.fg-primary',
      outlineOffset: '2px',
    },
    _disabled: {
      color: 'neutral.fg-disabled',
      cursor: 'not-allowed',
    },
  },
};
